import React from 'react'
import {connect} from "react-redux"
import Waypoint from 'react-waypoint';
import { Link } from 'react-router'
import Avatar from '../user/Avatar'
import {fetchTherapyAreas, fetchVideos, setModal, setTitle} from "../../actions/index"
import { listenToUserSessionNotifications } from '../../actions/comments'
import { updateSessionParentOpenToRead } from '../../actions/parent'
import { fetchParentPatientRecord, fetchSessions, fetchPatientAssessments } from '../../actions/patient'
import ShowAssessment from './ShowAssessment'
import ParentPatientSessionCard from '../parent/ParentPatientSessionCard'
import Sidenav from '../sidenav/Sidenav';
import MoreVerticalSVG from '../ui/images/MoreVerticalSVG'
import downArrow from '../../images/icons/arrow_down_white.svg'
import CategoryAreas from '../ui/CategoryAreas'
import FileImg from '../../images/icons/FileIcon'
import loaderImg from '../practice_admin/images/loader.gif'

//import Perf from 'react-addons-perf';
//window.Perf = Perf
//Perf.start()

import DatePicker from 'react-datepicker';
import ShowCategories from '../ui/ShowCategories'
import moment from 'moment'

import arrowRight from '../therapist/images/arrow-right.svg'
import folderSVG from '../therapist/images/folder-solid.svg'
import arrowRightDark from '../therapist/images/arrow-right-dark.svg'
import ThumbUpImg from '../../images/icons/thumb_up_black.svg'

const arrowStyle= {
  'marginLeft': '-10px'
}


// Expose the React Performance Tools on the`window` object
@connect((store) => {
    return {
        User: store.User.User, app: store.app, patients: store.patients,
        //practices: store.practices,
        patient_records: store.patient_records,
        therapy_areas: store.therapy_areas,
        therapy_categories: store.therapy_categories,
        videos: store.videos,
        assessments: store.assessments,
        modal: store.modal,
        sessions: store.sessions,
        notifications: store.notifications
    }
})
class ParentPatientRecord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            'patient_record': {
                patient: {},
                practice: {}
            },
            'patient_sessions_array': [],
            'patient_assessments_array': [],
            'assessment': {
                'therapy_areas': [],
                'videos': []
            },
            'sessionCommentText': '',
            'showAssessment': false,
            'active_assessment_category': null,
            'from': props.location.query.from || 0,
            'loading': true,
            loadingMore: false,
            'noMoreSessions': false,
            'blur': false,
            'toggledShowMore':'',            
			'homework': null,
			'filterBy': 'all',
			'filterDate': null,
			'currenetAssessment': null,
			'active_category':'',
			'jsHeadShow': false
        };
        this.assessmentCategoryClick = this.assessmentCategoryClick.bind(this)
        this.sessionClick = this.sessionClick.bind(this);
        this.setup = this.setup.bind(this)
        this.setSessionsArray = this.setSessionsArray.bind(this)
        this.toggleAssessment = this.toggleAssessment.bind(this)
        this._renderWaypoint = this._renderWaypoint.bind(this)
        this.fetchMoreSessions = this.fetchMoreSessions.bind(this)
        this.blur = this.blur.bind(this)
        this.toggleShowMore = this.toggleShowMore.bind(this)
		this.filterBy = this.filterBy.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.toggleHomework = this.toggleHomework.bind(this)
		this.getAssessmentsSessionsArray = this.getAssessmentsSessionsArray.bind(this)
		this.setAssessmentArray = this.setAssessmentArray.bind(this)
		this.assessmentClick = this.assessmentClick.bind(this)
		this.assessmentShow = this.assessmentShow.bind(this)
		this.toggle = this.toggle.bind(this)

    }

  componentWillMount(){
    let { patientRecordId, parentId } = this.props.params;
    this.setup(patientRecordId, parentId)
  }

  componentWillReceiveProps(nextProps){
		if(nextProps.app.authed && !this.props.app.authed){
		}

    if(nextProps.patientRecordId !== this.props.patientRecordId ){
      this.setup(nextProps.patientRecordId, nextProps.parentId)
    }
	}

	shouldComponentUpdate(nextProps){
		return Object.keys(nextProps.patient_records).length
	}

	assessmentCategoryClick(id) {		
		let _id = this.state.active_category === id ? null : id
	    this.setState({
	      "active_category": _id
	    })
	}

	blur(val){
		this.setState({
			'blur': val
		})
	}

	insertSessionUsers(session){
		let { dispatch } = this.props;
		let { patient_record } = this.state;
		let uids = {[session.therapist.uid]:true}

		if(patient_record.patient.parent.uid){
			uids[patient_record.patient.parent.uid] = true
		}
		if(patient_record.patient.guardians.lenght){
			patient_record.patient.guardians.forEach(uid =>{
				uids[uid] = true;
			})
		}

		dispatch({
			type: 'INSERT_SESSION_USERS',
			payload: {
				'users': uids,
				'sessionId': session._id
			}
		})
	}

	sessionClick(session){
		let {dispatch,videos , therapy_categories } = this.props;

		// add the therapist to the session users
		this.insertSessionUsers(session)
		console.log(session);
		dispatch(setModal('ParentSession', null, {
			sessionId: session._id,
			session: session,
			videos:videos,
			therapy_categories: therapy_categories,
			activeVideoId: null,
			setActiveVideo: this.setActiveVideo,
			toggleVideoDone: this.toggleVideoDone,
			addComment: true
		}, true, 'fullscreen'))
		dispatch(updateSessionParentOpenToRead(session.patientRecord, session._id));
	}

	assessmentClick(assessment){
		this.setState({
			assessment: assessment
		})
		this.toggle("showAssessment")
	}

	assessmentShow(){

		let { patient, therapy_areas, therapy_categories, User } = this.props;
		let { active_category, assessment } = this.state;

		const categoryAreas = () => assessment.therapy_areas
			.filter(areaId => {
				if (!therapy_areas[areaId]) return []
				return therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false
			}
			).map(areaId => therapy_areas[areaId])

		const age = () => {
			if (assessment.patient.dob && assessment) {
				let assessmentDate = assessment.doa || assessment.modified
				let duration = moment.duration(moment(assessmentDate).diff(assessment.patient.dob))
				return duration.years() + ' years ' + duration.months() + ' months'
			} else {
				return ''
			}
		}

		let interalNotes = '';
		// if (User.therapist) {
		// 	interalNotes = <span><h4>Internal Notes</h4><p>{assessment.internal_notes}</p></span>
		// }

		return <div id="assesmentFormScroll" className="assesmentFormScroll parentPatientRecord"><div className="card assessmentView wide assessment marginless">
				<div className="card-header">
					<div className="headerText">Assessment</div>
					<a className="link" onClick={() => this.toggle("showAssessment")}>&times;</a>
				</div>

				<div className="card-content">
					<table className="data" >
						<tr>
							<th width="30%">Date of Assessment</th>
							<td>{assessment.doa ? moment(assessment.doa).format('ddd Do of MMM YYYY') : moment(assessment.modified).format('ddd Do of MMM YYYY')}</td>
					</tr>
						<tr>
							<th width="30%">Age</th>
							<td>{age()}</td>
						</tr>
					</table>
					<span>
						{/*<h4>Parent Notes</h4>*/}
						<p>{assessment.description}</p>
					</span>
					{interalNotes}

				</div>
				<div className="card-content">
					<div className="md-body1">Therapy areas</div>
		                <ShowCategories
						active_category={active_category}
						click={this.assessmentCategoryClick}
						therapy_areas={assessment.therapy_areas.map(areaId => therapy_areas[areaId])}
						therapy_categories={therapy_categories}
					/>
					<CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />
				</div>

				<div className="card-content">
					<div className="md-body1">
						Documents
						</div>
					{assessment.documents.length ? assessment.documents.map(doc => {

						return <p key={`doc-${doc.name}`}>
							<a className="link right" onClick={() => this.deleteAssessmentDocument(doc)}><small>Delete</small></a>
							<FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
						</p>
					}) : null}

				</div>
				<div>
					{/*<div className="right">
						<DocumentUpload update={true} callback={d => this.addAssessmentDocument(d, assessment)} path={`documents/assessments/patients/${patient._id}/`} />
						<br /><br />
					</div>*/}
				</div>
			</div>
		</div>
	}

	setAssessmentArray() {
		const { assessments } = this.props;
		this.setState({
			'patient_assessments_array': assessments
		});
		// console.log(this.state.patient_assessments_array);
	}

	setSessionsArray(){
		let { sessions } = this.props;
		let sessions_array = Object.values(sessions).sort((a,b)=>{
				if(a.dateSent){
					// we need to check both dateSent and created for a while
					// TODO: Remove created later
					if (a.dateSent < b.dateSent) {
						return 1;
					}
					if (a.dateSent > b.dateSent) {
						return -1;
					}
				}else{
					if (a.created < b.created) {
						return 1;
					}
					if (a.created > b.created) {
						return -1;
					}
				}

				// ... must be equal
				return 0;
			});

		this.setState({
			'patient_sessions_array': sessions_array
		})
	}

  setup(patientRecordId, parentId){
    let { dispatch, User, params } = this.props;
		let { stateAssessment, from } = this.state;
		// this.setState({'loading': true})
    if(User){
			dispatch(listenToUserSessionNotifications(User.uid))
          dispatch(fetchVideos())
			dispatch(fetchPatientAssessments(parentId, patientRecordId))
			.then((assessment => {
				// if(assessment._id){
					this.setState({
						'assessment': {...stateAssessment, ...assessment},
						'patient_assessments_array':assessment
					})
				// }

			}))
			.catch(e => {
				console.log('No assessment');
			})

      dispatch(fetchTherapyAreas())
  			.then(()=>{
          dispatch(fetchParentPatientRecord(patientRecordId, parentId))
          .then(patient_record => {
            this.setPatientRecord(patient_record)

						dispatch(fetchSessions(patient_record._id, params.parentId, from ))
						.then(sessions => {
							this.setSessionsArray(sessions)
							this.setState({'loading':  false})
						})
          }).catch(err=>{
            console.log(err);
          })
  			})
    }
  }

	toggleAssessment(){
		let {showAssessment} = this.state;
		this.setState({
			showAssessment: !showAssessment
		})
	}

  setPatientRecord(patient_record){
		const { dispatch } = this.props;

    this.setState({
      'patient_record': patient_record
    })
		dispatch(setTitle(`${patient_record.patient.firstName || ''} ${patient_record.patient.lastName || ''}`))
  }

	fetchMoreSessions(){
		const { from } = this.state;
		const { dispatch, params } = this.props

		this.setState({'loadingMore':  true})

		dispatch(fetchSessions(params.patientRecordId, params.parentId, from+1 ))
		.then(sessions => {
			this.setSessionsArray(sessions)
			if(!sessions.length){
				this.setState({'noMoreSessions': true})
			}
			this.setState({'loading': false, 'from': from+1, loadingMore: false})
		})
	}

	_renderWaypoint(){
		return <div><p>No more sessions</p> </div>
	}

	toggleShowMore(id) {

		if (this.state.toggledShowMore === id){
			this.setState({ toggledShowMore:'' })
		} else {
			this.setState({ toggledShowMore:id })
		}
	}

	filterBy(event) {
		this.setState({
			filterBy: event.target.value
		});
	}

	filterByDate(date) {
		this.setState({
			filterDate: date
		});
	}

	toggleHomework(id) {
		// console.log(this.state)
		let homework = this.state.homework === id ? null : id;
		this.setState({
			homework: homework
		});
	}

	getAssessmentsSessionsArray() {
		let {
			patient_sessions_array,
			patient_assessments_array,
			filterBy,
			filterDate
		} = this.state;
		let assessmentsSessionsArray = [];

		if (filterBy === 'all' || filterBy === 'assessments') {
			// console.log('Assessments');
			for (const key in patient_assessments_array) {
				if (patient_assessments_array.hasOwnProperty(key)) {
					const assessment = patient_assessments_array[key];
					const tempDate = (assessment.doa !== null) ? assessment.doa : assessment.modified;
					if (moment(tempDate) >= filterDate) {
						assessmentsSessionsArray.push({
							'type': 'assessment',
							'date': tempDate,
							'data': assessment
						});
					}
				}
			}
		}

		if (filterBy === 'all' || filterBy === 'sessions') {
			// console.log('Sessions');
			patient_sessions_array.forEach(function (value, index) {
				if (moment(value.created) >= filterDate) {
					assessmentsSessionsArray.push({
						'type': 'session',
						'date': value.created,
						'data': value
					});
				}
			});
		}

		assessmentsSessionsArray.sort(function (a, b) {
			return new Date(b.date) - new Date(a.date);
		});

		// console.log(assessmentsSessionsArray);

		return assessmentsSessionsArray;
	}

	toggle(key, val) {
		console.log('key',key,'val',val)
		console.log(this.state.showAssessment)
		this.setState({
			[key]: typeof val === 'undefined' ? !this.state[key] : val
		})

		if (key === 'showAssessment') {
			if (this.state.showAssessment){
				document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.remove('show')})
				this.setState({'jsHeadShow':false})
			} else {
				document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.add('show')})
				this.setState({'jsHeadShow':true})
			}
		}
	}

  render(){
    let {therapy_areas, notifications, therapy_categories, videos} = this.props;
    let { loading, filterDate, filter, homework, blur, patient_record, assessment, patient_sessions_array,active_assessment_category, showAssessment} = this.state;
	let { practice } = patient_record;
	// console.log(this.props)
	let assessmentsSessionsArray = this.getAssessmentsSessionsArray()

	if (loading) {
		const divStyle = {
			'paddingTop': '50px',
			'fontSize': '.4em',
			'position': 'fixed',
			'transform': 'translate(-50%, -50%)',
			'top': '40%',
			'left': '50%',
			'display': 'flex',
			'flexDirection': 'column',
			'alignItems': 'center',
			'justifyContent': 'center'
		};
		
		// Need to style loading
		return (<div>
			<main className={"main"}>
				<div className="padding">
					<h4 style={divStyle}>
						<img src={loaderImg} alt=""/>
						<small>Loading</small>
					</h4>
				</div>
			</main>
		</div>);
	}

    return (<main className={"main parentPatientRecord"}>
		{/*<Sidenav ref="rightNav" callback={this.blur} className="right"  >
			<div>
				<div className="side-nav__content">
					<br /><br /><br />
					<div className="padding">
						<div className="padding card marginless " >
							<Link className="row" to={`/practice/${practice.slug}`}> &nbsp;{ practice.logo? <Avatar pic={practice.logo.thumb} /> : null } <div className="padding">{ practice.name }</div></Link>
						</div><br />
						<div className="fill">
							<button
							className={"md-button dark row pill " + (showAssessment && "active")}
							onClick={() => {
								this.toggleAssessment();
                                // eslint-disable-next-line
								this.refs.rightNav && this.refs.rightNav.closeMenu()
								}
							}>
							<img style={arrowStyle} src={downArrow} alt="Open" className={"down-arrow " + (showAssessment && "open")} height="32px" />
								Assessment
							</button>
						</div>
					</div>
				</div>
			</div>
		</Sidenav>
 		<div className={"parent-patient-page heigth110" + (blur? ' blur' : '')}>
			<div className="page-menu row">
				<div className="fill">&nbsp;</div>
				<div>
					{/*<MoreVerticalSVG click={this.refs.rightNav ? this.refs.rightNav.openMenu : null} />
				</div>
			</div>*/}
		{showAssessment && <div>{this.assessmentShow()}<br /></div>}

		{/* PATIENT MENU */}
		<div className="row patientMenu marginless">
				<div className="page-menu  row fill ">
					<div className="patientPhoto">
						{ /*{patient_record.patient.picture && <Avatar pic={`${patient_record.patient.picture.thumb}`} />} */}
					</div>
					<div className="patientInfo">
						{ <p>{patient_record.patient.firstName} {patient_record.patient.lastName}</p> }
						{/*<p>John Doe</p>*/}
						{/* <small>{(patient.parent) && patient.parent.name}</small> */}
						<small>Date of birth: { moment(patient_record.patient.dob).format('DD MMMM YYYY')}</small>
						{/* <small>{patient.archived}</small> */}
					</div>
					{/* <div className="patientButtons">
						<div className="buttons">
							<a onClick={() => this.toggle("editPatientOpen")} >EDIT</a>
							<a className={"newAssesment"} style={{display: (patient.archived !== undefined && patient.archived === true) ? 'none' : 'inline-block'}} onClick={() => {
									this.setState({ 'newAssessment': cleanNewAssessment });
									this.toggle('newAssessmentFormOpen');
									this.toggleNewSessionAssessmentMenu();
									// this.addClassToAppContent();
								}}>+ ASSESSMENT</a>
							{ this.actionButtons() }
						</div>
					</div> */}
				</div>
			</div>
		{/* PATIENT MENU */}

		{/* FILTER */}
		<div className="typeAndDateFilter">
			<div className="typeFilter">
				<label htmlFor="typeFilter">Type:</label>
				<select name="typeFilter" id="typeFilter" onChange={this.filterBy} value={filter}>
					<option value="all">All</option>
					<option value="sessions">Sessions</option>
					<option value="assessments">Assessments</option>
				</select>
			</div>
			<DatePicker
				// readOnly={true}
				popperPlacement="bottom-end"
				selected={filterDate}
				onChange={this.filterByDate}
				placeholderText="Date Range"
				dateFormat="YYYY/MM/DD"
				showYearDropdown
			/>
		</div>
		{/* FILTER */}

		{ 
			assessmentsSessionsArray.length ? assessmentsSessionsArray.map((session, index) => 
				<div key={index}>
					{ session.type === 'assessment' && 
					<ShowAssessment key={index}					
					index={index}
					patient={patient_record.patient}
					assessmentCategoryClick={this.assessmentCategoryClick}
					assessment={session}
					therapy_categories={therapy_categories}
					therapy_areas={therapy_areas}
					toggled={this.state.toggledShowMore}
					toggleShowMore={this.toggleShowMore}
					click={this.assessmentClick}
					active_category={active_assessment_category} >
					</ShowAssessment> }

					{session.type === 'session' && 
					<ParentPatientSessionCard key={session._id}
					notification={notifications.sessions[session._id]}
					session={session}
					index={index}
					videos={videos}
					patient={patient_record.patient}
					patientRecord={patient_record}
					toggled={this.state.toggledShowMore}
					toggleShowMore={this.toggleShowMore}
					homework={this.state.homework}
					toggleHomework={this.toggleHomework}
					click={this.sessionClick}>
					</ParentPatientSessionCard> }
				</div>
				)
			: ''
		}

			<div className="padding">

			{ this._renderWaypoint() }
			</div>
		{/* </div> */}


  </main>)
  }
}

export default ParentPatientRecord;



// WEBPACK FOOTER //
// ./src/components/parent/ParentPatientRecord.jsx